var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }